import colorConfigs from "../../configs/colorConfigs";

export const colors = {
  primaryColor: colorConfigs.primary,
  secondaryColor: colorConfigs.secondary,
  tertiaryColor: colorConfigs.tertiary,
  quaternaryColor: colorConfigs.quaternary,
  primaryActiveBg: colorConfigs.primaryActiveBg,
  greytext: colorConfigs.greytext,
  mainBodyColor: colorConfigs.mainbody,
  errorBg: colorConfigs.errorBg,
  backgroundColor: colorConfigs.backgroundColor,
  textColor: colorConfigs.textColor,
};

export const fonts = {
  primaryFont: 'Poppins, sans-serif',
  bold: 'GT Walsheim Bold, sans-serif',
  boldOblique: 'GT Walsheim Bold Oblique, sans-serif',
  medium: 'GT Walsheim Medium, sans-serif',
  mediumOblique: 'GT Walsheim Medium Oblique, sans-serif',
};

export const fontSizes = {
  small: '12px',
  medium: '14px',
  large: '16px',
  responsive: {
    navigation: 'clamp(1.1rem, 2.5vw, 1.2rem)',
    headline: 'clamp(2.5rem, 3vw, 3rem)',
    body: 'clamp(0.9rem, 1.5vw, 1rem)',
    button: 'clamp(0.9rem, 1.5vw, 1rem)',
    title: 'clamp(1.1rem, 2.5vw, 1.2rem)',
    sectionHeadline: 'clamp(1.8rem, 2.5vw, 2rem)',
    small: 'clamp(0.8rem, 1.5vw, 1rem)',
  },
};

export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 600,
};

export const lineHeights = {
  normal: '1.5',
  relaxed: '1.75',
  tight: '1.25',
};

export const fontStyles = {
  primaryFont: fonts.primaryFont,
  primaryColor: colors.primaryColor,
  secondaryColor: colors.secondaryColor,
  textColor: colors.textColor,
  fontSizeSmall: fontSizes.small,
  fontSizeMedium: fontSizes.medium,
  fontSizeLarge: fontSizes.large,
  fontWeightLight: fontWeights.light,
  fontWeightRegular: fontWeights.regular,
  fontWeightMedium: fontWeights.medium,
  fontWeightBold: fontWeights.bold,
};

export const typo = {
  navigation: {
    fontFamily: fonts.bold,
    fontSize: fontSizes.responsive.navigation,
    color: colors.tertiaryColor,
  },
  headline: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.responsive.headline,
    color: colors.tertiaryColor,
    lineHeight: lineHeights.tight,
  },
  sectionHeadline: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.responsive.sectionHeadline,
    color: colors.tertiaryColor,
    lineHeight: lineHeights.normal,
  },
  title: {
    fontFamily: fonts.bold,
    fontSize: fontSizes.responsive.title,
    color: colors.tertiaryColor,
    lineHeight: lineHeights.relaxed,
  },
  bodyContent: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.responsive.body,
    color: colors.tertiaryColor,
    lineHeight: lineHeights.relaxed,
  },
  button: {
    fontFamily: fonts.bold,
    fontSize: fontSizes.responsive.button,
    color: colors.tertiaryColor,
  },
  smallText: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.large,
    color: colors.tertiaryColor,
  },
  sideBar: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.responsive.navigation,
    color: colors.secondaryColor,
    lineHeight: lineHeights.relaxed,
  },
  smartFridge: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.responsive.title,
    color: colors.tertiaryColor,
    lineHeight: lineHeights.relaxed,
  },
  menuTitle: {
    fontFamily: fonts.medium,
    lineHeight: lineHeights.tight,
  },
  menuFonts: {
    fontFamily: fonts.medium,
  },
  label: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.small,
  },
  redText: {
    fontFamily: fonts.medium,
    fontSize: fontSizes.large,
    color: colorConfigs.errorBg,
  },
};
